/**
 * CaseStatusBadge (component-inventory.md §3.1) — maps a `Case.status` to a design-system
 * §10 badge tone:
 *   open      → "open"        (neutral)
 *   in_review → "in-progress" (info)
 *   closed    → "resolved"    (success)
 *   archived  → "muted"       (archived is not a §10 row; the quiet outline tone)
 */
import type { JSX } from 'react';

import type { CaseStatus } from '../../lib/api.ts';
import { Badge, type BadgeTone } from '../ui/badge.tsx';

const STATUS: Record<CaseStatus, { label: string; tone: BadgeTone }> = {
  open: { label: 'Open', tone: 'open' },
  in_review: { label: 'In review', tone: 'in-progress' },
  closed: { label: 'Closed', tone: 'resolved' },
  archived: { label: 'Archived', tone: 'muted' },
};

export function CaseStatusBadge({ status }: { status: CaseStatus }): JSX.Element {
  const { label, tone } = STATUS[status];
  return <Badge tone={tone}>{label}</Badge>;
}
